import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const MarketingLayout = ({
  activePage = 'home',
  children,
  className = '',
  mainClassName = '',
  showNavbar = true,
  showFooter = true,
}) => {
  return (
    <div
      data-testid="marketing-layout"
      className={`min-h-screen flex flex-col ${className}`.trim()}
    >
      {showNavbar ? <Navbar activePage={activePage} /> : null}
      <main className={`flex-1 ${mainClassName}`.trim()}>{children}</main>
      {showFooter ? <Footer /> : null}
    </div>
  );
};

export default MarketingLayout;
